import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, promoteSuccess, promoteFailure } from '../../actions/promotion/promote';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error } from '../../actions/error/error';

function* promoteModelData(action) {
  try {
    const { modelId, trainingId, deploymentType, dedicatedConfig, reason } = action.payload || {};

    const response = yield call(
      axios.post,
      `${config.API_URL}/deployments/`,
      {
        pipeline_id: modelId,
        training_id: trainingId,
        deployment_type: deploymentType,
        dedicated_config: dedicatedConfig || {},
        reason: reason || ''
      },
      { headers: getLocalUser() }
    );

    yield put(promoteSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    // The promotion API uses a coded envelope: {error: {code, message, details}};
    // extractErrorMessage flattens it to a human string so the inline Alert
    // never renders "[object Object]".
    yield put(promoteFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, promoteModelData);
} 